import PropTypes from "prop-types";

const SIZES = ["xlarge", "large", "small"];
const COLORS = ["default", "primary", "second"];

const Text = ({ value, size, color }) => {
  return (
    <div className={`avatar--text avatar--${size} avatar--bg--${color}`}>
      <span>{value}</span>
    </div>
  );
};

Text.propTypes = {
  value: PropTypes.string.isRequired,
  size: PropTypes.oneOf(SIZES),
  color: PropTypes.oneOf(COLORS),
};

Text.defaultProps = {
  size: "small",
  color: "primary",
};

export default Text;
